import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
    HomeIcon,
    UserGroupIcon,
    WrenchScrewdriverIcon,
    CalendarIcon,
    ArrowLeftOnRectangleIcon,
    PaintBrushIcon,
} from '@heroicons/react/24/outline';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/config';

function Sidebar() {
    const location = useLocation();
    const navigate = useNavigate();

    const navItems = [
        { name: 'Services', path: '/admin/services', icon: WrenchScrewdriverIcon },
        { name: 'Girls', path: '/admin/girls', icon: UserGroupIcon },
        { name: 'Availabilities', path: '/admin/availabilities', icon: CalendarIcon },
        { name: 'Styling', path: '/admin/styling', icon: PaintBrushIcon },
    ];

    const handleSignOut = async () => {
        try {
            await signOut(auth);
            navigate('/login');
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    return (
        <div className="fixed left-0 top-0 h-screen w-64 bg-gray-900 text-white p-4 flex flex-col z-50 shadow-xl">
            <div className="text-xl font-bold mb-8 p-2">Admin Panel</div>

            <nav className="flex-1">
                <ul className="space-y-2">
                    {navItems.map((item) => {
                        const Icon = item.icon;
                        const isActive = location.pathname === item.path;

                        return (
                            <li key={item.name}>
                                <Link
                                    to={item.path}
                                    className={`flex items-center space-x-3 p-3 rounded-lg transition-colors ${isActive
                                        ? 'bg-pink-700 text-white'
                                        : 'text-gray-300 hover:bg-gray-800'
                                        }`}
                                >
                                    <Icon className="w-6 h-6" />
                                    <span>{item.name}</span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>

            <button
                className="flex items-center space-x-3 p-3 text-gray-300 hover:bg-gray-800 rounded-lg mt-auto"
                onClick={handleSignOut}
            >
                <ArrowLeftOnRectangleIcon className="w-6 h-6" />
                <span>Logout</span>
            </button>
        </div>
    );
}

export default Sidebar;